import { Box, Drawer, IconButton, List, styled, useTheme } from "@mui/material";
import { ChartPie, History, Left, Trade, TrendTwo, Wallet } from "assets/Icon";
import { useEffect, useMemo, useState } from "react";

import MenuListItem from "./Components/MenuListItem";
import SanaCashLogo from "assets/logo/512x512.png";
import { getPortfolioBasketMenuViewList } from "store/slices/wallet/walletSlice";
import useDispatch from "hooks/useDispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// import { useSelector } from "react-redux";

function SideMenuDrawer({ open, onClose, drawerWidth }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showChildren, setShowChildren] = useState(false);

  const portfolioBasketMenu = useSelector(
    (state) => state.wallet.portfolioBasketMenu?.data
  );

  useEffect(() => {
    dispatch(getPortfolioBasketMenuViewList());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sideMenuItems = useMemo(() => {
    const result = [];

    portfolioBasketMenu?.forEach((p) => {
      if (p?.isHavePortfolio) {
        const navigateLink = `/wallet/portfolio/${p?.portfolioId}`;

        result.push({
          key: p?.portfolioId,
          name: p?.name,
          path: navigateLink,
          onClick: () => navigate(navigateLink),
          children: [],
        });
      }
    });

    portfolioBasketMenu?.forEach((basketMenu) => {
      const isBasket = basketMenu?.isHaveBasket;
      const navigateLink = `/wallet/basket/${basketMenu?.basketId}/${basketMenu?.portfolioId}`;

      if (isBasket) {
        const portfolioIndex = result.findIndex(
          (basket) => basket?.key === basketMenu?.portfolioId
        );

        if (portfolioIndex !== -1 && result?.[portfolioIndex]?.children) {
          result?.[portfolioIndex].children?.push({
            key: basketMenu?.id,
            name: basketMenu?.name,
            path: navigateLink,
            onClick: () => navigate(navigateLink),
          });
        } else {
          result.push({
            key: basketMenu?.id,
            name: basketMenu?.name,
            path: navigateLink,
            children: [],
            onClick: () => navigate(navigateLink),
          });
        }
      }
    });

    return [
      {
        key: "portfolio",
        name: "Portfolio",
        icon: <ChartPie color={theme.palette.text.main} stroke={3} />,
        path: "/portfolio",
        onClick: () => navigate("/portfolio"),
      },
      {
        key: "market",
        icon: <TrendTwo color={theme.palette.text.secondary} />,
        name: "Market",
        path: "/market",
        onClick: () => navigate("/market"),
      },
      {
        key: "trade",
        name: "Trade",
        icon: <Trade color={theme.palette.text.secondary} />,
        children: [
          {
            key: "basic-trade",
            name: "Basic Trade",
            path: "/trade/1/3",
            onClick: () => navigate("/trade/1/3"),
          },
          {
            key: "advanced-trade",
            name: "Advanced Trade",
            path: "/advanced-trade/1/3",
            onClick: () => navigate("/advanced-trade/1/3"),
          },
        ],
      },
      {
        key: "wallet",
        name: "Wallet",
        icon: <Wallet color={theme.palette.text.secondary} />,
        children: [...(result || [])],
      },
      {
        key: "history",
        name: "History",
        icon: <History color={theme.palette.text.secondary} />,
        children: [
          {
            key: "request-history",
            name: "Request History",
            path: "/history/request-history",
            onClick: () => navigate("/history/request-history"),
          },
          {
            key: "trade-history",
            name: "Trade History",
            path: "/history/trade-history?tradeTab=1",
            onClick: () => navigate("/history/trade-history?tradeTab=1"),
          },
          {
            key: "order-history",
            name: "Order History",
            path: "/history/trade-history?tradeTab=0",
            onClick: () => navigate("/history/trade-history?tradeTab=0"),
          },
          {
            key: "borrow",
            name: "Borrow",
            path: "/history/basket-history?typeId=2",
            onClick: () => navigate("/history/basket-history?typeId=2"),
          },
          {
            key: "repayment",
            name: "Repayment",
            path: "/history/basket-history?typeId=3",
            onClick: () => navigate("/history/basket-history?typeId=3"),
          },
          {
            key: "interest",
            name: "Interest",
            path: "/history/basket-history?typeId=4",
            onClick: () => navigate("/history/basket-history?typeId=4"),
          },
        ],
      },
    ];

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioBasketMenu]);

  return (
    <DrawerStyle
      drawerWidth={drawerWidth}
      variant="persistent"
      anchor="left"
      open={open}
      keepMounted
    >
      <DrawerHeader>
        <BackIconButton onClick={onClose}>
          <Left color={theme.palette.text.main} />
        </BackIconButton>

        <Logo>
          <img src={SanaCashLogo} alt="" />
        </Logo>
      </DrawerHeader>

      <List>
        {sideMenuItems?.map((item, index) => (
          <MenuListItem
            key={index}
            item={item}
            setShowChildren={setShowChildren}
            showChildren={showChildren}
          />
        ))}
      </List>
    </DrawerStyle>
  );
}

const DrawerStyle = styled(Drawer)(({ theme, drawerWidth, open }) => ({
  width: drawerWidth,
  zIndex: open ? "1000" : "-2",
  flexShrink: 0,

  ".MuiDrawer-paper": {
    background: theme.palette.modules.sideMenuSecondary,
    width: drawerWidth,
    boxSizing: "border-box",
    borderRight: "none",
  },
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),

  justifyContent: "flex-end",
  minHeight: "200px",
}));

const BackIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(1),
  right: theme.spacing(1),
}));

const Logo = styled(Box)(({ theme }) => ({
  width: "80%",
  height: "auto",
  margin: "auto",
  padding: theme.spacing(2),
  img: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
  },
}));

export default SideMenuDrawer;
